/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const optionDataSchema = z.object({
	id: z.string().uuid(),
	label: z.string(),
	position: z.number(),
	consentType: z.string().nullable(),
	escoSkills: z.array(z.object({ conceptUri: z.string(), preferredLabel: z.string(), confirmedByUser: z.boolean() }))
		.nullable(),
	escoMappingReason: z.string().nullable(),
})

export type OptionDataSchema = z.infer<typeof optionDataSchema>
